import { AuthService } from "./../../shared/models/auth.service";
import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { PrePostQuestionSearchModel } from "./pre-post-question-search.model";
import { Observable } from "rxjs/Observable";
import { WeGoConfig, IAPIResponse, DataListModel } from "../../shared/config";
import { JQueryHelperService } from "../../shared/models/jquery-helper.service";
import { PrePostQuestionInformationModel } from "./pre-post-question-information.model";

@Injectable()
export class PrePostTripQuestionOverviewService {
  private JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) {}

  public GetPrePostTripQuestionList(
    prePostQuestionSearchModel: PrePostQuestionSearchModel,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let url = WeGoConfig.API_PRE_POST_QUESTION_OVERVIEW;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let queryStringPrePostTripQuestionModel = this.JQueryHelper.Param(
      prePostQuestionSearchModel
    );
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    url =
      url +
      "?" +
      queryStringDataListModel +
      "&" +
      decodeURIComponent(queryStringPrePostTripQuestionModel);
    return this.http
      .get(url, options)

      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDrowdownQuestionName(
    prePostQuestionSearchModel: PrePostQuestionSearchModel
  ): Observable<IAPIResponse> {
    let getQuestionNameListUrl = WeGoConfig.API_GET_PRE_POST_QUESTION_NAME;
    let queryStringPrePostTripQuestionModel = this.JQueryHelper.Param(
      prePostQuestionSearchModel
    );
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    getQuestionNameListUrl =
      getQuestionNameListUrl +
      "?" +
      decodeURIComponent(queryStringPrePostTripQuestionModel);
    return this.http
      .get(getQuestionNameListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportPrePostTripQuestionList(prePostQuestionSearchModel: PrePostQuestionSearchModel, input?: DataListModel): any {
    let getUrl = WeGoConfig.API_PRE_POST_QUESTION__Export;
    input.currentPage = 0;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let queryStringBookingOverviewModel = this.JQueryHelper.Param(prePostQuestionSearchModel);
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    getUrl = getUrl + "?" + queryStringDataListModel + "&" + decodeURIComponent(queryStringBookingOverviewModel);
    return this.http.get(getUrl, options);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/pre-post-trip-question-overview/models/pre-post-question-overview.service.ts